import { IdType } from "../domain/idType";
import { idTypeService } from "../infrastructure/services/idTypeService";

export const getIdTypes = {
  async execute(): Promise<IdType[]> {
    return await idTypeService.execute();
  },
};
